<template>
  <div class="bulk-tags-wrapper" v-show='showing' v-click-outside='close'>
    <form @submit.prevent='submit'>
      <div class="search-wrapper">
        <input v-model='q' @keydown.enter='addTag()' type='text' :placeholder='qPlaceholder' class='form-control' />
      </div>

      <div class="selectable-tags-wrapper">
        <div v-if="q.length > 0 && !isExactMatch" @click="addTag()" class="selectable-tag">
          <b><i class="fa fa-plus"></i> {{ $t('tags_manager.create_tag') }}:</b> {{ q }}
        </div>
        <div v-for="tag in filteredTags" @click="toggleTag(tag)" :class="{ selected: selectedTags[tag.id] }" class="selectable-tag" :key='tag.id'>
          <i class="fa fa-tag"></i>
          {{ tag.name }}
        </div>
      </div>

      <input type='submit' class="btn btn-primary btn-sm" :value="$t('products.list.submit')" />
    </form>
  </div>
</template>

<script>
  export default {
    props: ['sharedFolder'],
    data() {
      return {
        showing: false,
        q: '',
        recordIds: [],
        folderIds: [],
        selectedTags: {},
      }
    },
    computed: {
      tags() {
        return this.lists.sharedTags || []
      },
      searchTerm() {
        return this.q.toLowerCase()
      },
      qPlaceholder() {
        return this.tags.length > 0 ? this.$t('tags_manager.search_tag') : this.$t('tags_manager.create_a_tag')
      },
      isExactMatch() {
        return this.tags.some(t => t.name.toLowerCase() === this.searchTerm)
      },
      filteredTags() {
        if (this.q.length === '')
          return this.tags

        return this.tags.filter(t => t.name.toLowerCase().indexOf(this.searchTerm) >= 0)
      }
    },
    methods: {
      loadTags() {
        return this.listStore.getSharedTags(this.sharedFolder.organization_id)
      },
      open( records) {
        this.recordIds = records
        this.selectedTags = {}

        this.loadTags().then(() => {
          this.showing = true
        })
      },
      close() {
        this.showing = false
      },
      addTag() {
        this.store.createSharedTag({ name: this.q, organization_id: this.sharedFolder.organization_id }).then(({data}) => {
          this.q = ''
          this.loadTags()
          this.toggleTag(data)
          this.$toastr.success(this.$t('products.list.tag_created'))
        })
      },
      toggleTag(tag) {
        if (this.selectedTags[tag.id])
          return this.$delete(this.selectedTags, tag.id)

        this.selectedTags = Object.assign({}, this.selectedTags, { [tag.id]: tag })
      },
      submit(e) {
        const params = {
          tag_ids: Object.keys(this.selectedTags),
          record_ids: this.recordIds,
          organization_id: this.sharedFolder.organization_id
        }

        if (this.recordIds.length > 0)
          this.store.connectSharedTags(params).then(() => {
            this.store.sendMetrics({name: 'bulk_connect_tag_with_shared_record', params: this.$route.params, path: this.$route.fullPath})
            this.$emit('success')
            this.close()

          })
      },
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../../styles/tags_manager"
  form
    position: absolute
    top: 46px
    left: 0
    background: #ffffff
    width: 100%
    border: 1px solid #c4c4c4
    border-radius: 3px
    padding: 5px
    z-index: 10
    .btn
      margin-top: 15px
      float: right
  .bulk-tags-wrapper
    width: 280px
    position: relative
  .selectable-tags-wrapper
    text-align: left
</style>
